import { store, getContext, getElement } from '@wordpress/interactivity';
//let menuTimeout = null;
const { actions } = store( 'pfw-wp-campbellsfoodservices-ca/menu-item', {
    
    actions: {
        toggleMenu(e) {
            const context = getContext();
            const { ref } = getElement();
            const pos = ref.getBoundingClientRect();
            

            if ( context.isMenuOpen ) {
                context.width = 0;
                context.isMenuOpen = false;
            } else {
                context.left = -pos.left;
                context.width = document.documentElement.getBoundingClientRect().width;
                context.isMenuOpen = true;
                console.log(ref.getBoundingClientRect().left, window.innerWidth, document.documentElement.clientWidth, document.documentElement.getBoundingClientRect().width );

            }
        },
        closeMenu(e) {
            if (!e) {
                return;
            }
            const context = getContext();
            const { ref } = getElement();
            let p = e.target;
            
            while (p && p != document) {
                if (typeof p.className ==  'string' && p.className.includes('menu-container__close-button')) {
                    break;
                }
                if (p == ref) {
                    return;
                }
                p = p.parentNode;
                
            }
            context.isMenuOpen = false;
            context.left = 0;
            context.width = 0;
        },
        setPos() {
            const context = getContext();
            const { ref } = getElement();
            if (context.isMenuOpen) {
                // if (menuTimeout) {
                //     clearTimeout(menuTimeout)
                // }
                // menuTimeout = setTimeout(function() {
                   
                    context.left = -ref.getBoundingClientRect().left;
                    context.width = document.documentElement.getBoundingClientRect().width;
                    //console.log(ref.getBoundingClientRect().left, window.innerWidth, document.documentElement.clientWidth, document.documentElement.getBoundingClientRect().width );
                //}, 200);
                
            }
        }
    }
} );